
import React from 'react';

const BelowBanner = (props) => {
  console.log(props.Para);
  return (
    <>
    <div className='container-zk pt-md-4 pb-md-4' id="website-responsive">
      <div className=''>
        <h1 className='fw-700 fs-zk-40 text-zk-primary text-raleway'>
          {props.Title}
        </h1>
        <p className='fw-400 fs-zk-16 text-poppins mt-2'>
          {props.Para}
        </p>
      </div>
    </div>
    </>
  );
}

export default BelowBanner;
